import { createBrowserRouter } from "react-router-dom";
import { FILE, ROOT } from "./path";
import App from "../App";
import { LandingPage, PageNotFound } from "pages";
import { HtmlView } from "components";
import { FC, ReactNode, useEffect } from "react";

type IRequireHttpsProps = {
  children: ReactNode
}

const RequireHttps:FC<IRequireHttpsProps> = ({ children }) => {
  useEffect(() => {
    if (window.location.protocol === "http:") {
      window.location.replace(`https://${window.location.host}${window.location.pathname}`);
    }
  }, []);
  
  return children;
};

export const router = createBrowserRouter([
  {
    path: ROOT,
    element: <RequireHttps><App /></RequireHttps>,
    children: [
      {
        path: ROOT,
        element: <LandingPage />,
      },
      {
        path: FILE,
        element: <HtmlView />,
      },
    ],
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
]);
